export default types => ({
  post: params => ({ type: types.POST, payload: params }),
  reset: () => ({ type: types.RESET }),
  cancel: () => ({ type: types.CANCEL }),
  failed: payload => ({ type: types.FAILED, payload: payload.response }),
  success: payload => ({ type: types.SUCCESS, payload: payload.response })
});
